import React, { useState } from "react";
import { Phone, Mail, MapPin, Clock, Globe } from "lucide-react";
import { toast } from "sonner";
import Seo, { ORG_SCHEMA } from "@/components/Seo";

export default function Contact() {
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  const submit = (e) => {
    e.preventDefault();
    toast.success("Mesajınız alındı, en kısa sürede dönüş yapacağız.");
    setForm({ name: "", email: "", message: "" });
  };

  return (
    <div className="kz-container py-12">
      <Seo title="İletişim" path="/iletisim" schema={ORG_SCHEMA}
           description="Kuzey Yapı Hırdavat iletişim: 0 553 942 67 89 · admin@kuzeyyapi.tr · Yeni Mahalle, Oktay-Olcay Yurtbay Cad. No:28/A, Çaycuma / Zonguldak"/>
      <div className="text-xs font-bold tracking-[0.2em] text-brand mb-2">İLETİŞİM</div>
      <h1 className="font-display text-4xl md:text-5xl font-black mb-10">Bize Ulaşın</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
        <div className="space-y-4">
          {[
            { id: "phone", Icon: Phone, title: "Telefon", text: "0 553 942 67 89" },
            { id: "email", Icon: Mail, title: "E-posta", text: "admin@kuzeyyapi.tr" },
            { id: "web", Icon: Globe, title: "Web", text: "www.kuzeyyapi.tr" },
            { id: "address", Icon: MapPin, title: "Adres", text: "Yeni Mahalle, Oktay-Olcay Yurtbay Caddesi No:28/A, Çaycuma / ZONGULDAK" },
            { id: "hours", Icon: Clock, title: "Çalışma Saatleri", text: "Hafta içi 08:30 - 18:30 · Cumartesi 09:00 - 17:00" },
          ].map((it) => (
            <div key={it.id} className="kz-card p-5 flex gap-4">
              <div className="w-12 h-12 bg-ink-100 flex items-center justify-center shrink-0">
                <it.Icon className="text-brand"/>
              </div>
              <div>
                <div className="font-display font-bold">{it.title}</div>
                <div className="text-sm text-ink-700">{it.text}</div>
              </div>
            </div>
          ))}
        </div>

        <form onSubmit={submit} className="kz-card p-6 space-y-4">
          <h3 className="font-display font-black text-xl">Mesaj Gönderin</h3>
          <input required placeholder="Adınız" value={form.name} onChange={(e)=>setForm({...form, name: e.target.value})} className="w-full border border-ink-200 px-3 py-2.5 outline-none focus:border-ink-900"/>
          <input required type="email" placeholder="E-posta" value={form.email} onChange={(e)=>setForm({...form, email: e.target.value})} className="w-full border border-ink-200 px-3 py-2.5 outline-none focus:border-ink-900"/>
          <textarea required rows={5} placeholder="Mesajınız" value={form.message} onChange={(e)=>setForm({...form, message: e.target.value})} className="w-full border border-ink-200 px-3 py-2.5 outline-none focus:border-ink-900"/>
          <button className="kz-btn-primary w-full">Gönder</button>
        </form>
      </div>
    </div>
  );
}
